import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

export default function shouldHidePNTInfoBarForSingleProposer(formId: string): boolean {
    const fullComposeViewState = getFullComposeViewState(formId);

    if (!fullComposeViewState) {
        return false;
    }

    return fullComposeViewState.isAcceptProposeNewTime;
}
